import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { getAllRecords } from "../api";

export default function VendorDetailPage({ vendorId }) {
  const [vendor, setVendor] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const [vendorResponse, rows] = await Promise.all([
          api.get("/vehicles/vendors"),
          getAllRecords("/vehicles"),
        ]);
        setVendor(
          (vendorResponse.data.data || []).find(
            (item) => item._id === vendorId,
          ) || null,
        );
        setVehicles(
          rows.filter(
            (row) =>
              String(row.vendorId?._id || row.vendorId) === String(vendorId),
          ),
        );
      } catch {
        setMessage("Unable to load vendor vehicles.");
      }
    };
    load();
  }, [vendorId]);

  return (
    <div className="vendor-detail-page">
      <div className="vehicle-heading">
        <div>
          <p>VENDOR MANAGEMENT</p>
          <Link className="vendor-back" to="/staff/dashboard/vendor-management">
            ← All vendors
          </Link>
          <h2>{vendor?.name || "Vendor"} Vehicles</h2>
        </div>
        <Link
          className="add-vehicle-button"
          to={`/staff/dashboard/vendor-management/${vendorId}/drivers`}
        >
          Manage Driver
        </Link>
      </div>
      {message && <div className="vehicle-toast">{message}</div>}
      <section className="portal-module">
        <h3>Vehicle List</h3>
        <div className="vehicle-table">
          <table>
            <thead>
              <tr>
                {[
                  "Vehicle Number",
                  "Type",
                  "Vehicle Supplier",
                  "Client / Delivery Location",
                  "Supplier Price",
                ].map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {vehicles.map((row) => (
                <tr key={row._id}>
                  <td>{row.vehicleNumber}</td>
                  <td>{row.vehicleType}</td>
                  <td>{row.vendorName}</td>
                  <td>
                    {row.clientName || "-"}
                    {row.clientLocationName
                      ? ` / ${row.clientLocationName}`
                      : ""}
                  </td>
                  <td>
                    {row.supplierPrice
                      ? `₹${row.supplierPrice} / ${row.supplierPaymentTerm?.replace("_", " ")}`
                      : "Own vehicle"}
                  </td>
                </tr>
              ))}
              {!vehicles.length && (
                <tr>
                  <td colSpan="5">No vehicles found for this vendor.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <h3>Vendor Drivers</h3>
        {vendor?.externalDrivers?.length ? (
          <ul>
            {vendor.externalDrivers.map((item) => (
              <li key={item._id}>
                {item.fullName} · {item.mobileNo}
              </li>
            ))}
          </ul>
        ) : (
          <p>No external drivers added.</p>
        )}
      </section>
    </div>
  );
}
